import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { ButtonComponent } from '../../../../../aptem-component-library/components/button/button.component';
import { ButtonConfig } from '../../../../../aptem-component-library/components/button/button.models';
import { TestletActionButtonsConfig, TestletActionButtonType } from './models/testlet-action-buttons.models';

@Component({
    selector: 'app-testlet-action-buttons',
    imports: [ButtonComponent, SvgIconComponent],
    templateUrl: './testlet-action-buttons.component.html',
    styleUrl: './testlet-action-buttons.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TestletActionButtonsComponent {
  @Input({ required: true }) public config: TestletActionButtonsConfig = {
    buttonTrackingContext: '',
    repeatButton: false,
    nextButton: false,
    startTestButton: false,
  };

  @Output() public buttonClicked: EventEmitter<TestletActionButtonType> = new EventEmitter();

  protected repeatButton: ButtonConfig = {
    color: 'secondary',
  };

  protected handleButtonClick(type: TestletActionButtonType) {
    this.buttonClicked.emit(type);
  }
}
